import React, { FC } from 'react';

type Props = {
  containerClassName?: string;
  contentClassName?: string;
};

const SkeletonBodyText: FC<Props> = ({
  containerClassName = '',
  contentClassName = '',
}) => (
  <div
    style={{ backfaceVisibility: 'hidden', willChange: 'opacity' }}
    className={`${containerClassName} Polaris-Skeleton flex-grow`}
  >
    <div className="h-8 relative">
      <div
        className={`${contentClassName} absolute bg-grey-placeholder left-0 right-0 bottom-0 top-0`}
      />
    </div>
  </div>
);

export default SkeletonBodyText;
